const show = (el) => {
  el.removeAttribute("aria-hidden");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = null;
  });
};

const hide = (el) => {
  el.setAttribute("aria-hidden", "true");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = -1;
  });
};

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderEl = this.querySelector("[data-slider]");
    this.slides = this.querySelectorAll("[data-slide]");
    this.prevButton = this.querySelector(".swiper-button-prev");
    this.nextButton = this.querySelector(".swiper-button-next");
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Autoplay }) => {
      const swiperParams = {
        modules: [Autoplay],
        slidesPerView: "auto",
        speed: 250,
        loop: false,
        allowTouchMove: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          1024: {
            centeredSlides: false,
          },
        },
        on: {
          slideChangeTransitionStart: () => {
            this.swiper.slides.forEach((slide) => {
              hide(slide);
            });
          },
          slideChangeTransitionEnd: () => {
            window.requestAnimationFrame(() => {
              this.swiper.slides.forEach((slide) => {
                console.log(`slide`, slide);
                slide.classList.contains("swiper-slide-visible")
                  ? show(slide)
                  : hide(slide);
              });
            });
          },
        },
      };

      this.swiper = new Swiper(this.sliderEl, swiperParams);

      this.swiper.slides.forEach((slide) => {
        slide.classList.contains("swiper-slide-visible")
          ? show(slide)
          : hide(slide);
      });
    });
  }
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", ProductCarousel);
}
